import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initStorage } from './lib/storage/factory';
import { libraryRepository } from './lib/repository';
import './i18n';
import './index.css';

// 配置 pdfjs worker（本地打包，不依赖 CDN）
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
// 设置全局变量供 hump-doc 的 PdfParser 读取
(globalThis as Record<string, unknown>).HUMP_PDF_WORKER_SRC = workerUrl;

// 启动前初始化存储
async function bootstrap() {
  const root = document.getElementById('root')!;

  try {
    await initStorage();
    await libraryRepository.ensureInitialized();
  } catch (e) {
    // 存储初始化失败不阻塞渲染——降级为无存储模式
    console.error('[Hump] Storage init failed:', e);
  }

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

bootstrap();
